"use strict";
// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
Object.defineProperty(exports, "__esModule", { value: true });
exports.TunnelAuthenticationSchemes = void 0;
class TunnelAuthenticationSchemes {
}
exports.TunnelAuthenticationSchemes = TunnelAuthenticationSchemes;
/** Authentication scheme for AAD (or Microsoft account) access tokens. */
TunnelAuthenticationSchemes.aad = 'aad';
/** Authentication scheme for GitHub access tokens. */
TunnelAuthenticationSchemes.github = 'github';
/** Authentication scheme for tunnel access tokens. */
TunnelAuthenticationSchemes.tunnel = 'tunnel';
//# sourceMappingURL=tunnelManagementClient.js.map